export const GET_GENRES='GET_GENRES';
export const GET_PLATFORMS='GET_PLATFORMS';
export const GET_GAMES='GET_GAMES';
export const GET_DETAIL='GET_DETAIL';
export const CLEAR_DETAIL='CLEAR_DETAIL';
export const FILTER_DATA='FILTER_DATA';
export const FILTER_GENRES='FILTER_GENRES';
export const FILTER_RATING='FILTER_RATING';
export const FILTER_NAME='FILTER_NAME';
export const ON_SEARCH_GAMES_NAME='ON_SEARCH_GAMES_NAME';
export const POST_VIDEOGAMES='POST_VIDEOGAMES';

export const URL_MAIN='https://pi-videogames-7.herokuapp.com';